import React from 'react';
import styled from 'styled-components';

import useModal from '@/hooks/useModal';
import InAAsk from '@/containers/modal/InA/InAAsk';
import LoginOrRegist from '@/containers/modal/login/LoginOrRegist';
import { FontStyle } from '@/utils/StyleUtil';

const LoginOrNonMemberWriting = () => {
    const { addModal, removeCurrentModal } = useModal();

    return (
        <div>
            <ContentContainer>로그아웃 상태입니다</ContentContainer>
            <ButtonContainer>
                <div
                    className="button left_button"
                    onClick={() => {
                        removeCurrentModal();

                        addModal({
                            key: 'fullScreen',
                            props: {
                                isCloseIconOnRight: false,
                                title: '',
                                content: <InAAsk content="" category={[]} fileNames={[]} title="" fileURLs={[]} />,
                                handleCloseModal: removeCurrentModal,
                            },
                        });
                    }}
                >
                    비회원 작성
                </div>
                <div
                    className="button right_button"
                    onClick={() => {
                        removeCurrentModal();

                        addModal({
                            key: 'fullScreen',
                            props: {
                                content: <LoginOrRegist />,
                                handleCloseModal: removeCurrentModal,
                            },
                        });
                    }}
                >
                    로그인
                </div>
            </ButtonContainer>
        </div>
    );
};

const ContentContainer = styled.div`
    ${({ theme }) => theme.flex.flexOnly}
    ${({ theme }) => theme.flex.justifyCenter};
    margin-top: 18px;
    margin-bottom: 52px;
    ${FontStyle(20, 28, '500', '#333333', -1.2)}
`;

const ButtonContainer = styled.div`
    ${({ theme }) => theme.flex.flexOnly}
    padding: 0 20px 30px 20px;

    .button {
        ${({ theme }) => theme.flex.flexOnly};
        ${({ theme }) => theme.flex.justifyCenter};
        flex: 1;
        height: 46px;
        border-radius: 8px;
        ${FontStyle(14, 18, '500', undefined, -1)};
    }
    .left_button {
        border: 1px solid ${({ theme }) => theme.colors.primary};
        background-color: #ffffff;
        margin-right: 8px;
        color: ${({ theme }) => theme.colors.primary};
    }
    .right_button {
        background-color: ${({ theme }) => theme.colors.primary};
        color: #ffffff;
    }
`;

export default LoginOrNonMemberWriting;
